import type { ProtoWallet } from '@ducat-unit/client-sdk';

import type { WalletType } from '@/context/types';
import { translateOutsideReact } from '@/i18n/client-translator';

import { getBoundWalletActionGuard, type WalletActionGuard, type WalletActionStage } from './wallet-action-guard';
import { canPerformVaultActions } from './wallet-policy';

// Established by the connector when constructing the wallet, never by persisted browser state.
const walletTypes = new WeakMap<ProtoWallet, WalletType>();

export function registerWalletType(wallet: ProtoWallet, walletType: WalletType | undefined): void {
  if (walletType) walletTypes.set(wallet, walletType);
}

export class VaultWalletUnsupportedError extends Error {
  readonly kind = 'vault-wallet-unsupported';
  constructor() {
    super(translateOutsideReact('common.wallet.vaultMetaMaskRequired'));
    this.name = 'VaultWalletUnsupportedError';
  }
}

export function assertVaultWalletAllowed(wallet: ProtoWallet, guard?: WalletActionGuard): void {
  const boundGuard = guard ?? getBoundWalletActionGuard(wallet);
  const registeredType = walletTypes.get(wallet);
  if (!canPerformVaultActions(registeredType ?? boundGuard?.snapshot?.walletType)) throw new VaultWalletUnsupportedError();
  if (boundGuard && !canPerformVaultActions(boundGuard.snapshot?.walletType)) throw new VaultWalletUnsupportedError();
}

export async function assertVaultActionFresh(wallet: ProtoWallet, stage: WalletActionStage): Promise<void> {
  assertVaultWalletAllowed(wallet);
  await getBoundWalletActionGuard(wallet)?.assertFresh(stage);
}
